var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFacturation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0781 15.3438H3.92188C1.9375 15.3438 0.3125 16.9531 0.3125 18.9531V76.0625C0.3125 78.0625 1.9375 79.6875 3.92188 79.6875H76.0625C78.0625 79.6875 79.6719 78.0625 79.6719 76.0781V18.9531C79.6875 16.9531 78.0625 15.3438 76.0781 15.3438Z",
    fill: "#E23232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9688 59.7813V15.3438H6.875V59.4062H0.3125V76.0625C0.3125 78.0625 1.9375 79.6875 3.92188 79.6875H76.0625C78.0625 79.6875 79.6719 78.0625 79.6719 76.0781V59.7813H72.9688Z",
    fill: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1562 0.3125H8.70312V64.8438H71.2969V14.4531L57.1562 0.3125Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1562 14.4531H71.2969L57.1562 0.3125V14.4531Z",
    fill: "#E65555"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.3125 14.4531H71.2969V15.8594H58.3125V14.4531Z",
    fill: "#FF4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2969 12.7188H49.6875V15.8594H31.2969V12.7188Z",
    fill: "#E65555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2969 21.8125H63.4531V24.9531H31.2969V21.8125Z",
    fill: "#E65555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30.9062H63.4375V34.0469H17.5V30.9062Z",
    fill: "#E65555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 40H63.4375V43.1406H17.5V40Z",
    fill: "#E65555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1094 44.0156H46.7344C45.6719 44.0156 44.6719 43.5469 44 42.7344L34.9844 31.9375C34.3125 31.125 33.2969 30.6562 32.25 30.6562H3.75C1.85937 30.6562 0.3125 32.1875 0.3125 34.0938V76.25C0.3125 78.1406 1.84375 79.6875 3.75 79.6875H76.25C78.1406 79.6875 79.6875 78.1562 79.6875 76.25V47.5781C79.6875 45.6094 78.0938 44.0156 76.1094 44.0156Z",
    fill: "#FD8087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25 77.5156H3.75C1.85937 77.5156 0.3125 75.9844 0.3125 74.0781V76.25C0.3125 78.1406 1.84375 79.6875 3.75 79.6875H76.25C78.1406 79.6875 79.6875 78.1562 79.6875 76.25V74.0781C79.6875 75.9687 78.1562 77.5156 76.25 77.5156Z",
    fill: "#F05252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 28.625V27.125C18.75 26.9375 17.0625 26.1875 15.5781 24.8906L17.0781 23.1094C18.2344 24.1094 19.4063 24.7031 20.625 24.8906V20.9063C19.0781 20.5313 17.9375 20.0469 17.2188 19.4531C16.5 18.8437 16.1406 17.9531 16.1406 16.7656C16.1406 15.5781 16.5469 14.6094 17.375 13.8594C18.2031 13.1094 19.2812 12.6875 20.6094 12.625V11.5938H21.9219V12.6406C23.4219 12.75 24.8594 13.2656 26.1875 14.1875L24.8594 16.0781C23.9531 15.4375 22.9844 15.0313 21.9219 14.8906V18.75H21.9844C23.5625 19.125 24.7187 19.625 25.4531 20.25C26.1875 20.875 26.5625 21.7969 26.5625 23C26.5625 24.2031 26.1406 25.1719 25.2813 25.9219C24.4375 26.6719 23.3125 27.0781 21.9062 27.1562V28.6406H20.625V28.625ZM19.1719 15.3594C18.8281 15.6719 18.6563 16.0469 18.6563 16.5156C18.6563 16.9687 18.7969 17.3437 19.0625 17.6094C19.3281 17.875 19.8594 18.1406 20.625 18.375V14.8125C20.0156 14.875 19.5312 15.0625 19.1719 15.3594ZM23.5 24.375C23.8906 24.0625 24.0781 23.6562 24.0781 23.1875C24.0781 22.7031 23.9219 22.3281 23.625 22.0469C23.3281 21.7656 22.7656 21.5 21.9375 21.25V24.9531C22.5937 24.875 23.1094 24.6875 23.5 24.375Z",
    fill: "#F1786B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacturation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facturation.38d0d945.svg";
export { ForwardRef as ReactComponent };